import { ArrowUpRight, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[#040810]">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="h-9 w-9 rounded-full grid place-items-center bg-teal text-[#050A0F] font-display font-bold text-xl">
                R
              </div>
              <div>
                <div className="font-display font-semibold text-lg tracking-tight">
                  RevGrow<span className="text-teal">.</span>
                </div>
                <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-muted-foreground">
                  Services (UK) · Revgrow Limited
                </div>
              </div>
            </div>
            <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
              RevGrow-Services.co.uk is the services arm of regrow.co.uk, registered
              as Revgrow Limited. Established to deliver AI-native demand generation
              on top of the sales consulting services offered by the parent company.
            </p>
            <div className="mt-6 flex items-start gap-3 text-sm text-muted-foreground">
              <MapPin size={16} className="mt-0.5 text-teal" />
              <div>
                <div className="text-foreground">Registered Office</div>
                <div>87 Lozells Street, Birmingham B19 2AP, United Kingdom</div>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-muted-foreground mb-4">
              Company
            </div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="/#capabilities" className="hover:text-teal transition">Capabilities</a></li>
              <li><a href="/#owned-media" className="hover:text-teal transition">Owned media</a></li>
              <li><a href="/#framework" className="hover:text-teal transition">AI-Native Framework</a></li>
              <li><a href="/#case-studies" className="hover:text-teal transition">Case studies</a></li>
              <li><Link to="/insights" className="hover:text-teal transition">Insights</Link></li>
              <li><Link to="/deck" className="hover:text-teal transition">Executive deck</Link></li>
              <li><a href="/#why" className="hover:text-teal transition">Why RevGrow</a></li>
              <li><Link to="/privacy" className="hover:text-teal transition">Privacy policy</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-muted-foreground mb-4">
              Get in touch
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2.5">
                <Mail size={15} className="text-teal" />
                <a href="mailto:sales@revgrow.co.uk" className="hover:text-teal">sales@revgrow.co.uk</a>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone size={15} className="text-teal" />
                <a href="tel:+441174635393" className="hover:text-teal">+44 117 463 5393</a>
              </li>
              <li className="pt-3">
                <a
                  href="https://techbytes.org.uk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-teal hover:opacity-80"
                >
                  Visit TechBytes.org.uk <ArrowUpRight size={14} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-muted-foreground">
            © {new Date().getFullYear()} Revgrow Limited · All rights reserved.
          </div>
          <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-muted-foreground">
            Built for B2B · Powered by AI
          </div>
        </div>
      </div>
    </footer>
  );
}
